import { render } from "./Formvalidation.vue?vue&type=template&id=068baa28"
import script from "./Formvalidation.vue?vue&type=script&lang=js"
export * from "./Formvalidation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__